var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _circle, _path0, _path1, _g2, _path10, _g3, _g4, _g5, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoVoyager(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo-voyager",
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 50.5,
    viewBox: "0 0 121.08 33.969",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M19.554,2.592a1.613,1.613,0,0,0,.463.184,4.616,4.616,0,0,0,1.111.184c.091.463.091.834.184,1.194A1.706,1.706,0,0,1,21.5,4.8a.327.327,0,0,0,.091.186.325.325,0,0,1,.093-.186c.093-.184.093-.37.184-.554a6.45,6.45,0,0,0,.282-1.288,4.6,4.6,0,0,0,1.108-.184.717.717,0,0,0,.463-.184c.093,0,.093-.093.186-.093-.093,0-.093-.093-.186-.093a.717.717,0,0,0-.463-.184,4.838,4.838,0,0,0-1.108-.28A5.37,5.37,0,0,0,21.962.748c-.093-.186-.093-.37-.184-.557a.325.325,0,0,0-.1-.191.315.315,0,0,1-.093.184,1.343,1.343,0,0,0-.184.557,6.324,6.324,0,0,0-.186,1.194,4.582,4.582,0,0,0-1.108.186l-.557.277c-.093,0-.184,0-.184.093A.315.315,0,0,0,19.554,2.592Z",
    transform: "translate(-14.743)",
    fill: "#109ed9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M.184,30.48a1.314,1.314,0,0,0,.557.186,4.735,4.735,0,0,0,1.111.184,5.387,5.387,0,0,0,.184,1.194c.093.184.093.37.186.554a.327.327,0,0,0,.091.186.325.325,0,0,1,.093-.186c.093-.184.093-.37.186-.554a4.735,4.735,0,0,0,.184-1.111,4.62,4.62,0,0,0,1.111-.186c.184-.091.37-.091.554-.184a.2.2,0,0,1,.186-.184c-.093,0-.093-.093-.186-.093a1.3,1.3,0,0,0-.554-.186,4.735,4.735,0,0,0-1.111-.184,5.528,5.528,0,0,0-.184-1.194,1.718,1.718,0,0,0-.186-.647.325.325,0,0,0-.093-.184.318.318,0,0,1-.091.184,1.335,1.335,0,0,0-.186.647,4.668,4.668,0,0,0-.184,1.194A4.735,4.735,0,0,0,.741,30.1a1.314,1.314,0,0,0-.557.205c-.091,0-.091.093-.184.093a.289.289,0,0,0,.184.091Z",
    transform: "translate(0 -21.227)",
    fill: "#109ed9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M3.193,11.421c.091.093.277.093.37.186A2.064,2.064,0,0,0,4.3,11.7c0,.28.093.557.093.834,0,.093.093.277.093.37a.315.315,0,0,0,.093.191.289.289,0,0,1,.091-.184.554.554,0,0,0,.093-.37,2.678,2.678,0,0,0,.186-.834c.277,0,.461-.091.738-.091.093,0,.28-.093.37-.093a.091.091,0,0,0,.093-.093.091.091,0,0,1-.093-.091c-.184-.093-.277-.093-.37-.186-.277,0-.554-.093-.738-.093,0-.277-.093-.554-.093-.831,0-.093-.093-.277-.093-.37a.325.325,0,0,0-.093-.186.291.291,0,0,1-.091.186c-.093.184-.093.277-.186.37a2.537,2.537,0,0,0-.093.831c-.277,0-.554.093-.738.093-.093.093-.28.093-.37.186a.091.091,0,0,0-.093.084Z",
    transform: "translate(-2.359 -7.36)",
    fill: "#109ed9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M19.738,23.958V22.477L23.62,18.59v5.368a6.8,6.8,0,0,0,.834,3.517,6.113,6.113,0,0,0,3.053,2.219,6.529,6.529,0,0,0,3.053-2.219,5.87,5.87,0,0,0,.834-3.517V20.071h3.892v3.887a9.876,9.876,0,0,1-2.038,6.293,10.258,10.258,0,0,1-5.734,3.423,10.258,10.258,0,0,1-5.734-3.423A9.876,9.876,0,0,1,19.738,23.958Z",
    transform: "translate(-15.02 -14.149)",
    fill: "#333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M155.51,22.94v-.463L159.4,18.59v4.35a2.881,2.881,0,0,0,2.867,2.867h1.945a2.883,2.883,0,0,0,2.867-2.867V20.074h3.884V22.94a6.921,6.921,0,0,1-5.829,6.754v3.887h-3.884V29.6a6.624,6.624,0,0,1-5.734-6.66Z",
    transform: "translate(-118.359 -14.149)",
    fill: "#333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M228.209,24.79a6.792,6.792,0,0,1,6.756,6.754v4.35l-3.887,3.887V35.43h-7.771V38.3H219.42V31.544a6.792,6.792,0,0,1,6.754-6.754Zm2.867,6.754a2.881,2.881,0,0,0-2.867-2.867h-1.942a2.963,2.963,0,0,0-2.96,2.867h7.771Z",
    transform: "translate(-167.001 -18.868)",
    fill: "#333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M293.566,24.786h10.64l-3.887,3.607h-6.754A2.884,2.884,0,0,0,290.7,31.26a3.134,3.134,0,0,0,2.867,3.146h4.811V33.114h-4.811V29.968h8.7V38.3h-8.7a6.755,6.755,0,1,1,0-13.511Z",
    transform: "translate(-218.292 -18.864)",
    fill: "#333"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M364.294,34.506h11.661V38.3H360.41V24.79H377.9l-3.887,3.423h-9.716v1.758h9.716v2.96h-9.716Z",
    transform: "translate(-274.309 -18.868)",
    fill: "#333"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M443.944,24.79a4.343,4.343,0,0,1,4.348,4.35,4.539,4.539,0,0,1-2.867,4.164l5.091,5.091h-5.454l-8.338-8.33v9.807l-3.884-3.884V24.79Zm-7.219,3.239V29.6h7.31c.28,0,.463-.277.463-.741a1,1,0,0,0-.184-.554c-.093-.186-.186-.186-.37-.186Z",
    transform: "translate(-329.436 -18.868)",
    fill: "#333"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(26.675 8.283)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 2.592,
    cy: 1.758,
    rx: 2.592,
    ry: 1.758,
    fill: "#fff"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_900",
    "data-name": "Ellipse 900",
    cx: 7.692,
    cy: 7.692,
    r: 7.692,
    transform: "translate(21.369 4.895)",
    fill: "#1b75bb"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M56.168,27.627a5.853,5.853,0,0,1,6.013-1.672A6.531,6.531,0,0,1,66.72,30.58a6.414,6.414,0,0,1,0,3.239A5.669,5.669,0,0,1,64.961,36.5a22.755,22.755,0,0,1-2.406,1.758c-.831.557-1.758,1.111-2.59,1.672l-3.615,2.5c-1.851,1.388-3.61,2.867-5.368,4.35L48.487,49c.461-1.111.831-2.313,1.295-3.423,0-.093.093-.184.093-.277L47.84,46.782l-3.887,2.776L41.361,51.5l-.091.093,1.672-2.222,2.776-3.794.925-1.295L43.5,46.225l-.831.463a71.347,71.347,0,0,0,5.358-6.476,58.571,58.571,0,0,0,3.33-5c.834-1.295,1.574-2.592,2.315-3.98a35.2,35.2,0,0,1,2.219-3.33c.186-.093.28-.184.28-.277C58.387,25.035,52.651,31.884,56.168,27.627Z",
    transform: "translate(-31.411 -19.567)",
    fill: "#109ed9"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_84289",
    "data-name": "Path 84289",
    d: "M60.89,31.142a6.73,6.73,0,0,0-7.31-6.013,5.812,5.812,0,0,0-3.7,1.942,27.631,27.631,0,0,0-3.333,5.172,62.7,62.7,0,0,1-4.255,6.672,77.008,77.008,0,0,1-5.645,6.663c-.834.831-1.572,1.849-2.406,2.776l.647-.463,2.592-1.758c.511-.3,1-.619,1.486-.939-.557.736-1.116,1.517-1.672,2.234-.831,1.111-1.572,2.222-2.406,3.333-.647.741-1.194,1.572-1.758,2.313l1.481-1.018L37.017,50.3l2.771-2.035c.97-.717,1.983-1.433,2.979-2.133-.239.659-.478,1.328-.717,2a.373.373,0,0,1-.048.038h.036l-.674,1.945,1.388-1.3c1.111-1.018,2.315-2.035,3.423-3.053l3.345-2.776c.741-.554,1.572-1.194,2.313-1.758,1.283-1.018,2.58-1.849,3.961-2.774a31.742,31.742,0,0,0,2.867-2.035A5.256,5.256,0,0,0,59.679,35.4a4.9,4.9,0,0,0,1.02-1.942,6.558,6.558,0,0,0,.191-2.317Zm-.463,1.851a5.086,5.086,0,0,1-.925,2.035,11.015,11.015,0,0,1-1.111,1.018,18.672,18.672,0,0,1-2.776,1.945c-1.388.831-2.776,1.758-4.061,2.683-.834.554-1.672,1.111-2.5,1.758-1.572,1.194-3.053,2.406-4.625,3.7l-.815.717c.389-1.063.717-1.926,1.194-3.216l-.368.28-1.07.776-.05-.038-.038.1-3.017,2.212-2.415,1.761c-.385.239-.753.5-1.118.767.387-.564.786-1.13,1.209-1.694.557-.925,1.194-1.758,1.851-2.683l.616-.877c.072-.045.143-.1.217-.141l-.069-.069.994-1.412c-.647.463-1.388.834-2.129,1.3l-1.285.889c1.006-1.18,2-2.389,2.95-3.665a61.251,61.251,0,0,0,3.887-5.648c.834-1.388,1.672-2.776,2.5-4.257a27.272,27.272,0,0,1,2.683-3.978A5.781,5.781,0,0,1,57,26.063,6.39,6.39,0,0,1,60.426,32.993Z",
    transform: "translate(-25.215 -19.104)",
    fill: "#1b75bb"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(17.057 7.282)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M71.4,48.13h0c6.57-9.159,2.683-11.1,7.406-15.915a5.755,5.755,0,0,1,8.235,0l.093.093a5.977,5.977,0,0,1,.091,8.421C82.688,45.264,78.894,42.579,71.4,48.13Z",
    transform: "translate(-71.4 -30.481)",
    fill: "#1d76bb",
    fillRule: "evenodd"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_84290",
    "data-name": "Path 84290",
    d: "M94.67,32.58h0a5.084,5.084,0,0,0-7.124,0c-4.061,4.164-.65,5.831-6.386,13.789l5.867-5.841L81.253,46.46c7.864-5.829,9.623-2.5,13.694-6.66A5.207,5.207,0,0,0,94.67,32.58Z",
    transform: "translate(-61.771 -23.688)",
    fill: "#1b75bb",
    fillRule: "evenodd"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(24.895 7.651)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M105.56,40.091a4.779,4.779,0,0,1,0-6.663,4.662,4.662,0,0,1,6.57-.093h0a4.776,4.776,0,0,1,0,6.663,4.506,4.506,0,0,1-6.57.093Z",
    transform: "translate(-104.207 -32.028)",
    fill: "#233a75",
    fillRule: "evenodd"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(24.572 7.721)",
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M111.052,40.252c-1.849,1.851-5.366,2.406-7.124.554s-1.194-5.366.554-7.124a4.646,4.646,0,1,1,6.57,6.57Z",
    transform: "translate(-102.857 -32.32)",
    fill: "#109ed9"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(25.256 10.729)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 1.295,
    cy: 0.834,
    rx: 1.295,
    ry: 0.834,
    fill: "#fff"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M112.841,45.75a4.465,4.465,0,0,1-1.388,2.96c-1.849,1.758-4.348,2.222-6.211.554a5,5,0,0,1-1.018-1.672,3.928,3.928,0,0,0,.834,3.333c1.479,1.388,4.811,1.295,6.66-.37A4.322,4.322,0,0,0,112.841,45.75Z",
    transform: "translate(-79.295 -34.82)",
    fill: "#1b75bb"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_84291",
    "data-name": "Path 84291",
    d: "M129.476,96.385V93.47h.657v3.949h-.652l-2.023-2.886v2.886H126.8V93.47h.69Z",
    transform: "translate(-96.508 -71.14)",
    fill: "#333"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_84292",
    "data-name": "Path 84292",
    d: "M144.461,99.039h0a.9.9,0,0,0,.956.81,1.672,1.672,0,0,0,.989-.284v.576a1.863,1.863,0,0,1-1.034.272,1.538,1.538,0,0,1-.119-3.072,1.192,1.192,0,0,1,1.261,1.355v.332Zm1.433-.425c-.012-.459-.239-.717-.662-.717a.772.772,0,0,0-.745.717Z",
    transform: "translate(-109.469 -74.086)",
    fill: "#333"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_84293",
    "data-name": "Path 84293",
    d: "M157.951,99.1l1.089,1.512h-.75l-.717-1.027-.717,1.027h-.717l1.089-1.505-1.022-1.433h.757l.65.941.638-.941h.721Z",
    transform: "translate(-118.839 -74.337)",
    fill: "#333"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_84294",
    "data-name": "Path 84294",
    d: "M168.825,95.387h.444V94.67h.65v.717h.836v.557h-.836v1.4c0,.354.153.478.4.478a1.015,1.015,0,0,0,.54-.167v.592a1.567,1.567,0,0,1-.717.158.808.808,0,0,1-.882-.908V95.943h-.444Z",
    transform: "translate(-128.489 -72.054)",
    fill: "#333"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_84295",
    "data-name": "Path 84295",
    d: "M187.683,94.208a1.651,1.651,0,0,0-1.116-.411,1.335,1.335,0,0,0-1.374,1.433,1.356,1.356,0,0,0,1.374,1.448,1.474,1.474,0,0,0,.585-.093V95.391h.676v1.572a2.53,2.53,0,0,1-1.273.291,1.933,1.933,0,0,1-2.059-2.038,1.961,1.961,0,0,1,2.031-2.031,2.2,2.2,0,0,1,1.149.3Z",
    transform: "translate(-140.419 -70.923)",
    fill: "#333"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_84296",
    "data-name": "Path 84296",
    d: "M201.721,99.039h0a.9.9,0,0,0,.956.81,1.672,1.672,0,0,0,.989-.284v.576a1.863,1.863,0,0,1-1.034.272,1.538,1.538,0,0,1-.119-3.072,1.192,1.192,0,0,1,1.261,1.355v.332Zm1.433-.425a.626.626,0,0,0-.662-.717.77.77,0,0,0-.745.717Z",
    transform: "translate(-153.05 -74.086)",
    fill: "#333"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_84297",
    "data-name": "Path 84297",
    d: "M215.23,97.679a3.99,3.99,0,0,1,1.347-.239c.75,0,1.228.284,1.228,1.116v1.885h-.65v-1.83c0-.425-.265-.578-.631-.578a2.315,2.315,0,0,0-.638.086v2.322h-.657Z",
    transform: "translate(-163.812 -74.162)",
    fill: "#333"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_84298",
    "data-name": "Path 84298",
    d: "M229.391,99.039h0a.9.9,0,0,0,.956.81,1.687,1.687,0,0,0,.989-.284v.576a1.871,1.871,0,0,1-1.037.272,1.538,1.538,0,0,1-.119-3.072,1.191,1.191,0,0,1,1.261,1.355v.332Zm1.433-.425c-.014-.459-.239-.717-.664-.717a.768.768,0,0,0-.743.717Z",
    transform: "translate(-174.11 -74.086)",
    fill: "#333"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_84299",
    "data-name": "Path 84299",
    d: "M243.557,100.463H242.9v-2.7a2.4,2.4,0,0,1,1.149-.291,1.957,1.957,0,0,1,.564.074v.635a1.593,1.593,0,0,0-.564-.093,1.319,1.319,0,0,0-.492.093Z",
    transform: "translate(-184.872 -74.184)",
    fill: "#333"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_84300",
    "data-name": "Path 84300",
    d: "M253.037,98.424c0-.318-.239-.463-.564-.463a1.644,1.644,0,0,0-.85.239v-.571a1.957,1.957,0,0,1,.956-.239c.645,0,1.1.265,1.1,1v1.945a4.3,4.3,0,0,1-1.008.119c-.764,0-1.321-.239-1.321-.9,0-.6.511-.889,1.362-.889h.325Zm0,.683h-.28c-.459,0-.757.134-.757.432s.28.425.678.425a2.532,2.532,0,0,0,.358-.033Z",
    transform: "translate(-191.303 -74.124)",
    fill: "#333"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_84301",
    "data-name": "Path 84301",
    d: "M263,95.387h.444V94.67h.65v.717h.836v.557h-.836v1.4c0,.354.153.478.406.478a1.013,1.013,0,0,0,.538-.167v.592a1.562,1.562,0,0,1-.717.158.81.81,0,0,1-.884-.908V95.943H263Z",
    transform: "translate(-200.17 -72.054)",
    fill: "#333"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_84302",
    "data-name": "Path 84302",
    d: "M273.846,92.673a.413.413,0,1,1,.2.384A.413.413,0,0,1,273.846,92.673Zm.753,3.849h-.657V93.576h.657Z",
    transform: "translate(-208.424 -70.243)",
    fill: "#333"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_84303",
    "data-name": "Path 84303",
    d: "M281.337,97.388a1.536,1.536,0,1,1-1.512,1.538,1.467,1.467,0,0,1,1.512-1.538Zm0,.564a.98.98,0,1,0,.858.975A.871.871,0,0,0,281.337,97.951Z",
    transform: "translate(-212.974 -74.121)",
    fill: "#333"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_84304",
    "data-name": "Path 84304",
    d: "M295.39,97.679a3.968,3.968,0,0,1,1.347-.239c.75,0,1.228.284,1.228,1.116v1.885h-.652v-1.83c0-.425-.265-.578-.631-.578a2.284,2.284,0,0,0-.635.086v2.322h-.657Z",
    transform: "translate(-224.822 -74.162)",
    fill: "#333"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_84305",
    "data-name": "Path 84305",
    d: "M315.25,93.264a8.138,8.138,0,0,1,1.049-.074c1.574,0,2.317.817,2.317,1.971a2.013,2.013,0,0,1-2.3,2.1,7.168,7.168,0,0,1-1.063-.072Zm.676,3.378a3.5,3.5,0,0,0,.447.026,1.385,1.385,0,0,0,1.539-1.507c0-.848-.545-1.347-1.586-1.347a3.819,3.819,0,0,0-.4.022Z",
    transform: "translate(-239.938 -70.927)",
    fill: "#333"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_84306",
    "data-name": "Path 84306",
    d: "M333,98.424c0-.318-.239-.463-.564-.463a1.644,1.644,0,0,0-.85.239v-.571a1.956,1.956,0,0,1,.956-.239c.643,0,1.1.265,1.1,1v1.945a4.3,4.3,0,0,1-1.008.119c-.764,0-1.321-.239-1.321-.9,0-.6.511-.889,1.362-.889H333Zm0,.683h-.28c-.459,0-.757.134-.757.432s.28.425.678.425a2.532,2.532,0,0,0,.358-.033Z",
    transform: "translate(-252.161 -74.124)",
    fill: "#333"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_84307",
    "data-name": "Path 84307",
    d: "M343,95.387h.444V94.67h.65v.717h.836v.557h-.836v1.4c0,.354.153.478.406.478a1.013,1.013,0,0,0,.538-.167v.592a1.562,1.562,0,0,1-.717.158.81.81,0,0,1-.884-.908V95.943H343Z",
    transform: "translate(-261.058 -72.054)",
    fill: "#333"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_84308",
    "data-name": "Path 84308",
    d: "M355,98.424c0-.318-.239-.463-.564-.463a1.644,1.644,0,0,0-.85.239v-.571a1.964,1.964,0,0,1,.956-.239c.645,0,1.1.265,1.1,1v1.945a4.341,4.341,0,0,1-1.011.119c-.762,0-1.321-.239-1.321-.9,0-.6.511-.889,1.362-.889H355Zm0,.683h-.28c-.456,0-.755.134-.755.432s.277.425.676.425a2.5,2.5,0,0,0,.358-.033Z",
    transform: "translate(-268.905 -74.124)",
    fill: "#333"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_84309",
    "data-name": "Path 84309",
    d: "M371.623,95.079a1.292,1.292,0,0,1-.411-.9.956.956,0,0,1,1.056-.956.943.943,0,0,1,1.061.956,1.194,1.194,0,0,1-.717,1.061l.743.8a1.911,1.911,0,0,0,.213-.8h.564a2.15,2.15,0,0,1-.394,1.2l.731.781h-.791l-.337-.358a1.94,1.94,0,0,1-1.209.418c-.8,0-1.3-.4-1.3-1.08,0-.545.32-.831.836-1.077Zm.392.411a.781.781,0,0,0-.526.7c0,.351.268.578.69.578a1.307,1.307,0,0,0,.8-.272Zm.253-.631a.717.717,0,0,0,.456-.676.42.42,0,0,0-.452-.437.4.4,0,0,0-.43.423.822.822,0,0,0,.306.566Z",
    transform: "translate(-282.24 -70.95)",
    fill: "#333"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_84310",
    "data-name": "Path 84310",
    d: "M392.493,96.505l-.346.936h-.717l1.534-3.942h.829l1.541,3.942H394.6l-.344-.929Zm.882-2.375-.676,1.818h1.347Z",
    transform: "translate(-297.919 -71.163)",
    fill: "#333"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_84311",
    "data-name": "Path 84311",
    d: "M409.91,97.679a3.968,3.968,0,0,1,1.347-.239c.75,0,1.228.284,1.228,1.116v1.885h-.643v-1.83c0-.425-.265-.578-.631-.578a2.284,2.284,0,0,0-.635.086v2.322h-.657Z",
    transform: "translate(-311.984 -74.162)",
    fill: "#333"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_84312",
    "data-name": "Path 84312",
    d: "M425.147,98.424c0-.318-.239-.463-.564-.463a1.644,1.644,0,0,0-.85.239v-.571a1.973,1.973,0,0,1,.956-.239c.643,0,1.1.265,1.1,1v1.945a4.341,4.341,0,0,1-1.011.119c-.762,0-1.319-.239-1.319-.9,0-.6.509-.889,1.359-.889h.325Zm0,.683h-.277c-.459,0-.757.134-.757.432s.277.425.676.425a2.5,2.5,0,0,0,.358-.033Z",
    transform: "translate(-322.297 -74.124)",
    fill: "#333"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_84313",
    "data-name": "Path 84313",
    d: "M437.457,95.6H436.8V91.08h.657Z",
    transform: "translate(-332.45 -69.321)",
    fill: "#333"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_84314",
    "data-name": "Path 84314",
    d: "M443.114,99.985l.822-2.315h.678l-1.586,4.14h-.645l.411-1.063-1.214-3.072h.7Z",
    transform: "translate(-336.088 -74.337)",
    fill: "#333"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_84315",
    "data-name": "Path 84315",
    d: "M455.057,95.387h.444V94.67h.652v.717h.836v.557h-.836v1.4c0,.354.153.478.4.478a1.008,1.008,0,0,0,.538-.167v.592a1.548,1.548,0,0,1-.717.158.81.81,0,0,1-.884-.908V95.943h-.444Z",
    transform: "translate(-346.34 -72.054)",
    fill: "#333"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_84316",
    "data-name": "Path 84316",
    d: "M465.92,92.581a.411.411,0,1,1,.411.411A.411.411,0,0,1,465.92,92.581Zm.736,3.849H466V93.484h.657Z",
    transform: "translate(-354.613 -70.151)",
    fill: "#333"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_84317",
    "data-name": "Path 84317",
    d: "M474.268,98.27a1.235,1.235,0,0,0-.779-.272.891.891,0,0,0-.941.956.91.91,0,0,0,.97.956,1.28,1.28,0,0,0,.781-.265v.626a1.746,1.746,0,0,1-.87.217,1.46,1.46,0,0,1-1.546-1.534,1.479,1.479,0,0,1,1.546-1.538,1.613,1.613,0,0,1,.839.217Z",
    transform: "translate(-359.15 -74.142)",
    fill: "#333"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_84318",
    "data-name": "Path 84318",
    d: "M484.355,99.6a1.544,1.544,0,0,0,.9.332c.294,0,.478-.1.478-.332s-.172-.325-.549-.425c-.612-.139-.87-.385-.87-.9,0-.6.452-.889,1.049-.889a1.524,1.524,0,0,1,.843.225v.6a1.362,1.362,0,0,0-.824-.3c-.284,0-.437.139-.437.332s.124.291.463.385c.671.146.956.4.956.929,0,.619-.478.9-1.108.9a1.737,1.737,0,0,1-.91-.239Z",
    transform: "translate(-368.61 -74.122)",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVoyager);
export default __webpack_public_path__ + "static/media/logo-voyager.394628e08e089e721d57188d755a1c28.svg";
export { ForwardRef as ReactComponent };